import { ApiUrl } from "../utils/modules";

class SondageQuestionsServices {
  constructor(api) {
    this.api = api;
  }

  create(question) {
    return this.api.post(ApiUrl + "sondagequestion", question);
  }

  getAll() {
    return this.api.get(ApiUrl + "sondagequestion");
  }

  getOne(id) {
    return this.api.get(ApiUrl + "sondagequestion/" + id);
  }

  update(id, question) {
    return this.api.patch(ApiUrl + "sondagequestion/" + id, question);
  }

  delete(id) {
    return this.api.delete(ApiUrl + "sondagequestion/" + id);
  }
}

export default SondageQuestionsServices;